module.exports = __webpack_public_path__ + "img/realestate.c389d740.svg";